'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$() {
  this.aMF = null;
  this.aMM = null;
  this.aMG = null;
  this.aMH = false;
  this.aMK = null;
  this.aML = false;
  this.aMI = null;
  this.aMJ = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ = this;
  this.aMF = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$();
  this.aMM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aMF;
});
$p.eO = (function() {
  return this.aMM;
});
$p.aG = (function() {
  if ((!this.aMH)) {
    this.aMG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aMH = true;
  }
  return this.aMG;
});
$p.az = (function() {
  if ((!this.aML)) {
    this.aMK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aML = true;
  }
  return this.aMK;
});
$p.asl = (function() {
  if ((!this.aMJ)) {
    this.aMI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Reference Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aMJ = true;
  }
  return this.aMI;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$, "app.data.data_point_types$package$ItemReferenceNumberForm$", ({
  G4: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$() {
  this.aMD = null;
  this.aME = false;
  this.aMB = null;
  this.aMC = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aME)) {
    this.aMD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aME = true;
  }
  return this.aMD;
});
$p.AL = (function() {
  if ((!this.aMC)) {
    this.aMB = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$().asl();
    this.aMC = true;
  }
  return this.aMB;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$, "app.data.data_point_types$package$ItemReferenceNumber$", ({
  G3: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Item-Reference-Number$.js.map
